import React, { Fragment } from "react";
import { AppBar } from "react-admin";
import { useMediaQuery, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import Announcements from "../../components/common/Announcements";
import { KbChatButton } from "../../components/common/KbChatButton";
import { AppBarHeader } from "../../components/common/AppBarHeader";

const useStyles = makeStyles((theme) => ({
  title: {
    flex: 1,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  hidden: {
    display: "none",
  },
  logo: {
    margin: "auto",
    paddingTop: theme.spacing(1),
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
  },
  spacer: { flex: 1 },
}));

export const ManagerAppBar = (props, userMenu, kbChat = {}) => {
  const smDown = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const classes = useStyles();
  const svgLogo = "/logo_transloads_white.svg";

  return smDown ? (
    <>
      <AppBar {...props} color="primary" userMenu={userMenu}>
        <span className={classes.spacer} />
        <Typography
          variant="h6"
          color="inherit"
          id="react-admin-title"
          className={classes.hidden}
        />
        <AppBarHeader>
          <div className={classes.logo}>
            <img src={svgLogo} alt="transloads.co logo" height="30px" />
          </div>
        </AppBarHeader>
        <span className={classes.spacer} />
      </AppBar>
      <Announcements />
    </>
  ) : (
    <>
      {/* container={Fragment} makes the appBar fixed */}
      <AppBar
        {...props}
        color="primary"
        userMenu={userMenu}
        container={Fragment}
      >
        <Typography
          variant="h6"
          color="inherit"
          id="react-admin-title"
          className={classes.title}
        />
        <AppBarHeader>
          <div className={classes.logo}>
            <img src={svgLogo} alt="transloads.co logo" height="30px" />
          </div>
        </AppBarHeader>
        <span className={classes.spacer} />
        <KbChatButton onOpenChange={kbChat?.onOpenChange} />
      </AppBar>
      <Announcements />
    </>
  );
};
